import React from "react";
import { Link } from "react-router-dom";
import { Query, withApollo } from "react-apollo";
import { Menu, Container, Icon, Header } from "semantic-ui-react";

import LanguageSelector from "../pages/Contents/New/LanguageSelector";
import { LANGUAGES_QUERY, APPLICATIONS_QUERY } from "graphql/queries";
import { withLanguage, withApplicationId } from 'HOCs'

class Navigation extends React.Component {
  state = {
    language: '',
    languages: []
  }
  async componentDidMount() {
    const {
      data: { languages }
    } = await this.props.client.query({ query: LANGUAGES_QUERY });
    this.setState(state => {
      const language= this.props.language
      return {languages, language: (language? language: languages[0].value)}
    });
  }
  componentDidUpdate(prevProps, prevState){
    if (prevState.language !== this.state.language){
      this.props.history.push({...this.props.location.pathName, search: this.languageQuery(this.state.language)})
    }
  }
  setLanguage = (language) => {
    this.setState({language})
  }
  languageQuery = (language) => {
    const params = new URLSearchParams()
    params.set("language", language)
    return params.toString()
  }

  logout = async () => {
    await localStorage.clear();
   this.props.history.push("/login");
  };

  render() {
    const { url } = this.props.match;
    if (this.props.applicationId) {
      return (
        <Query query={APPLICATIONS_QUERY} variables={{language: this.props.language}}>
          {({data: {applications}, loading, error}) => {
            if (applications) {
            const currApplication = applications.find(application => application.id === this.props.applicationId)
            let color
            switch(currApplication.name) {
              case 'cadence': 
                color = "blue"
                break;
              case 'carrottop':
                color= "violet"  
                break;
              default:
                color= "grey"
                break;    
              }
            return (
              <div style={{ marginBottom: 80 }}>
                <Menu fixed="top" color={color} inverted secondary>
                  <Container>
                    <Menu.Item header>{currApplication.name}</Menu.Item>
                    <Menu.Item as={Link} to={`/applications?${this.props.languageQuery}`}>
                      <Icon name="arrow left" />
                      Back to Applications
                    </Menu.Item>
                    <Menu.Item as={Link} to={`${url}/contents?${this.props.languageQuery}`}>
                      Contents
                    </Menu.Item>
                    <Menu.Item as={Link} to={`${url}/categories?${this.props.languageQuery}`}>
                      Categories
                    </Menu.Item>
                    <Menu.Item as="a" onClick={this.logout}>
                      Logout
                    </Menu.Item>
                  </Container>
                </Menu>
              </div>
            )
          }
            return null
          }}
        </Query>
        
      )
    }
    return (
      <div style={{ marginBottom: 80 }}>
        <Menu fixed="top" inverted>
          <Container>
            <Menu.Item as={Link} to="/" header>
              BSC Platform Admin
            </Menu.Item>
            <Menu.Item as={Link} to={`/applications?${this.props.languageQuery}`}>
              Applications
            </Menu.Item>
            <Menu.Item as={Link} to={`/tags?${this.props.languageQuery}`}>
              Tags
            </Menu.Item>
            <Menu.Item as="a" onClick={this.logout}>
              Logout
            </Menu.Item>
            <Menu.Menu position="right">
              <Menu.Item> 
                <LanguageSelector
                  language={this.state.language}
                  languageOptions={this.state.languages}
                  setLanguage={this.setLanguage}
                />
              </Menu.Item>
            </Menu.Menu>
          </Container>
        </Menu>
      </div>
    );
  }
}
export default withApplicationId(withLanguage(withApollo(Navigation)))



// WEBPACK FOOTER //
// ./src/components/Navigation.js